import { ProductStatus } from "../types/typescript-axios";

export const productStatusToString = (status: ProductStatus) => status === ProductStatus.NUMBER_1 ? '公開' : '非公開'
